import { render, staticRenderFns } from "./EditKeywords.vue?vue&type=template&id=375fcea1&"
import script from "./EditKeywords.vue?vue&type=script&lang=js&"
export * from "./EditKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports